// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_a7-4";
export var collapsed = "_a7-1";
export var headerBar = "_a7-0";
export var leftHeaderContent = "_a7-3";
export var subjectContainer = "_a7-2";